export const SERVER_HOST_QR = 'https://demo.lfs.rest/api/v4/'
export const DEFAULT_LANG = 'en'

